import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { CheckIcon, SparklesIcon } from 'lucide-react';
type PricingTier = {
  name: string;
  price: string;
  period: string;
  description: string;
  features: string[];
  cta: string;
  popular?: boolean;
};
const tiers: PricingTier[] = [{
  name: 'Obserwator',
  price: '97',
  period: '/miesiąc',
  description: 'Idealny start dla początkujących traderów.',
  features: ['Dostęp do biblioteki podstawowej', 'Cotygodniowe webinary', 'Społeczność Discord', 'Newsletter z analizami'],
  cta: 'Rozpocznij'
}, {
  name: 'Analityk',
  price: '297',
  period: '/miesiąc',
  description: 'Dla aktywnych traderów rozwijających umiejętności.',
  features: ['Wszystko z planu Obserwator', 'Pełna biblioteka materiałów', 'Symulator tradingu', 'Sygnały i alerty', 'Miesięczne sesje Q&A'],
  cta: 'Wybierz plan',
  popular: true
}, {
  name: 'Strateg',
  price: '697',
  period: '/miesiąc',
  description: 'Kompleksowe wsparcie dla profesjonalistów.',
  features: ['Wszystko z planu Analityk', 'Sesje mentorskie 1:1', 'Zaawansowane narzędzia', 'Priorytetowe wsparcie', 'Dostęp do API', 'Certyfikacja'],
  cta: 'Skontaktuj się'
}];
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-gray-900/50" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-212">
          <motion.span initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-amber-400 text-sm font-medium tracking-wider uppercase" data-id="element-213">
            Cennik
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl sm:text-4xl font-bold text-white mt-4 mb-4" data-id="element-214">
            Przejrzyste plany subskrypcji
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-gray-400 max-w-2xl mx-auto" data-id="element-215">
            Wybierz plan dopasowany do Twoich potrzeb. Możesz zmienić lub
            anulować w dowolnym momencie.
          </motion.p>
        </div>

        {/* Pricing Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch" data-id="element-216">
          {tiers.map((tier, index) => <motion.div key={tier.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative" data-id="element-217">
              {tier.popular && <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10" data-id="element-218">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-amber-500 text-gray-900 text-xs font-semibold rounded-full" data-id="element-219">
                    <SparklesIcon className="w-3 h-3" data-id="element-220" />
                    Najpopularniejszy
                  </span>
                </div>}

              <Card className={`p-8 h-full flex flex-col ${tier.popular ? 'border-amber-500/50 bg-gray-900/80' : ''}`} glow={tier.popular ? 'accent' : 'none'} data-id="element-221">
                <div className="mb-6" data-id="element-222">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-223">
                    {tier.name}
                  </h3>
                  <p className="text-gray-500 text-sm" data-id="element-224">{tier.description}</p>
                </div>

                <div className="mb-6" data-id="element-225">
                  <span className="text-4xl font-bold text-white font-mono" data-id="element-226">
                    {tier.price}
                  </span>
                  <span className="text-gray-500" data-id="element-227"> PLN{tier.period}</span>
                </div>

                <ul className="space-y-3 mb-8 flex-1" data-id="element-228">
                  {tier.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-229">
                      <CheckIcon className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-230" />
                      <span className="text-gray-300 text-sm" data-id="element-231">{feature}</span>
                    </li>)}
                </ul>

                <Button variant={tier.popular ? 'accent' : 'secondary'} size="lg" className="w-full" data-id="element-232">
                  {tier.cta}
                </Button>
              </Card>
            </motion.div>)}
        </div>

        {/* Note */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center text-gray-500 text-sm mt-8" data-id="element-233">
          Wszystkie ceny są podane w PLN i zawierają VAT. Płatność kartą lub
          przelewem.
        </motion.p>
      </div>
    </section>;
}